export const environment = {
  production: true,
  buildId: '2815106271119281',
  configFile: 'config.json',
};
